// extracted by mini-css-extract-plugin
export default {"root":"haEWP__root","scrollExpiredMsg":"bbsIS__scrollExpiredMsg"};